export function capitalize(s: string): string {
  if (typeof s !== 'string') return '';
  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
}

export function formatNumberToMb(number: number): string {
  return number.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatNumberToComma(number: number): string {
  return number.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
